
const config = {
  uid: null,
  appId: "45cf757b815b4f56aac4a2adb3d6a974",
  channelName: "",
  rtcToken: "",
  serverUrl: "http://localhost:8080/",
  proxyUrl: "http://localhost:8080/",
  tokenExpiryTime: 600,
  token: "",
  encryptionMode: "aes-128-gcm2",
  salt: "",
  encryptionKey: "",
  destChannelName: "",
  destChannelToken: "",
  destUID: 2,
  secondChannel: "",
  secondChannelToken: "",
  secondChannelUID: 2,
  selectedProduct: "rtc"
};

export default config;